<div class="row">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement label="AuftragsNr">
      {{ auftragEntry.batchAuftragListEntry.auftragNr }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="AuftragsTyp">
      {{ "datenexport." + auftragEntry.batchAuftragListEntry.datenexportAuftragTyp | translate }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="Verarbeitungsstatus">
      {{ auftragEntry.batchAuftragListEntry.exportResultWebTyp | translate }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="ErstelltVon">
      {{ auftragEntry.batchAuftragListEntry.ersteller | kompaktBenutzer }}
    </cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement label="Erstelldatum">
      {{ auftragEntry.batchAuftragListEntry.erstelldatum | datumZeit }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="Startdatum">
      {{ auftragEntry.batchAuftragListEntry.startdatum | datumZeit }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="Enddatum">
      {{ auftragEntry.batchAuftragListEntry.enddatum | datumZeit }}
    </cap-kopfdatenelement>
  </div>
</div>
